import { render, staticRenderFns } from "./BPage.vue?vue&type=template&id=4b091b6d&scoped=true&"
import script from "./BPage.vue?vue&type=script&lang=js&"
export * from "./BPage.vue?vue&type=script&lang=js&"
import style0 from "./BPage.vue?vue&type=style&index=0&id=4b091b6d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b091b6d",
  null
  
)

export default component.exports